/**
 * Délai de reprise : min(3600 s, 5 s x 3^(tentatives-1)) +/- 20 % d'aléa
 * (5 s, 15 s, 45 s, 2 min 15, 6 min 45, 20 min, 1 h, puis toutes les heures). Jamais d'abandon.
 */
export const BACKOFF_BASE_MS = 5_000;
export const BACKOFF_MAX_MS = 3_600_000;
export const BACKOFF_JITTER = 0.2;

/** Délai nominal (sans aléa) après `attempts` échecs comptés (>= 1). */
export function nominalBackoffMs(attempts: number): number {
  const n = Math.max(1, Math.floor(attempts));
  // 3^40 dépasse largement le plafond : on évite les flottants géants.
  const exp = Math.min(n - 1, 12);
  return Math.min(BACKOFF_MAX_MS, BACKOFF_BASE_MS * 3 ** exp);
}

/**
 * @param attempts échecs comptés (>= 1)
 * @param random   tirage dans [0, 1)
 * @param retryAfterMs `Retry-After` du serveur : il prime s'il est plus long
 */
export function backoffDelayMs(attempts: number, random: () => number, retryAfterMs = 0): number {
  const nominal = nominalBackoffMs(attempts);
  const jitter = 1 + (random() * 2 - 1) * BACKOFF_JITTER;
  const delay = Math.round(nominal * jitter);
  return Math.max(delay, Number.isFinite(retryAfterMs) ? Math.max(0, retryAfterMs) : 0);
}

/** Sondes hors ligne : 5 s, 10 s, 20 s, 40 s puis toutes les 60 s (+/- 20 %). */
export function probeDelayMs(failedProbes: number, random: () => number): number {
  const schedule = [5_000, 10_000, 20_000, 40_000];
  const base = schedule[Math.max(failedProbes, 0)] ?? 60_000;
  return Math.round(base * (1 + (random() * 2 - 1) * BACKOFF_JITTER));
}
